import * as React from "react";
import { QESButton } from "@app/shared/qes-standards/Button";
import { QESSelect } from "@app/shared/qes-standards/forms/Select";
import { QESTextInput } from "@app/shared/qes-standards/forms/TextInput";
import { Client } from "@app/client/client";

interface UserSearchProps {
  clients: Client[];
  getUsers: (value: string, type: "name" | "client") => void;
}

interface UserSearchState {
  disableSearchButton: boolean;
  nameSearch: string;
  searchBy: "name" | "client";
  selectedClient: string;
}

class UserSearch extends React.Component<UserSearchProps, UserSearchState> {
  constructor(props: UserSearchProps) {
    super(props);

    this.state = {
      disableSearchButton: true,
      nameSearch: "",
      searchBy: "name",
      selectedClient: "",
    };
  }

  public componentDidUpdate() {
    if (this.state.searchBy === "name") {
      // search by name view
      if (this.state.nameSearch !== "") {
        // input has value
        if (this.state.disableSearchButton) {
          this.setState({
            disableSearchButton: false,
          });
        }
      } else {
        // input does not have value
        if (!this.state.disableSearchButton) {
          this.setState({
            disableSearchButton: true,
          });
        }
      }
    } else {
      // search by client view
      if (this.state.selectedClient !== "") {
        // client selected
        if (this.state.disableSearchButton) {
          this.setState({
            disableSearchButton: false,
          });
        }
      } else {
        // no client selected
        if (!this.state.disableSearchButton) {
          this.setState({
            disableSearchButton: true,
          });
        }
      }
    }
  }

  public render() {
    return (
      <div>
        <div className="row">
          <div className="col-12">
            <legend className="mb-3">
              Search for Users
            </legend>
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <div className="input-group mb-3 border-0">
              {this.state.searchBy === "name" ?
                <QESTextInput
                  containerClassName="flex-fill"
                  label="Username"
                  hideLabel={true}
                  onChange={this.onNameSearchInputChange}
                  onKeyUp={(e) => this.onUsernameKeyUp(e)}
                  testId="user-search__username-input"
                  type="input"
                  value={this.state.nameSearch}
                /> :
                <QESSelect
                  label="Client Name"
                  hideLabel={true}
                  testId="user-search__client-name-select"
                  id="application-client-select"
                  onChange={this.onClientSelect}
                  value={this.state.selectedClient}
                >
                  <option value="">Select a client</option>
                  {this.props.clients.map((client, index) => (
                    <option key={index} value={client.clientId} >
                      {client.name}
                    </option>
                  ))}
                </QESSelect>
              }

              <QESButton
              className="input-group-append"
              qesTestId="user-search_search"
                disabled={this.state.disableSearchButton}
                onClick={() => this.handleSearch()}
              >
                <i className="fa fa-search" />
              </QESButton>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            <div className="mb-3">
              <div className="d-inline-block cursor-pointer me-3" onClick={() => this.onSearchTypeChange("name")}>
                <i className={`me-1 fa fa-` + (this.state.searchBy === "name" ? `stop-circle-o` : `circle-o`)} />
                Search by name/username
              </div>
              <div className="d-inline-block cursor-pointer" onClick={() => this.onSearchTypeChange("client")}>
                <i className={`me-1 fa fa-` + (this.state.searchBy === "client" ? `stop-circle-o` : `circle-o`)} />
                Search by client
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  private onNameSearchInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      nameSearch: event.target.value,
    });
  }

  private onSearchTypeChange = (searchBy: "name" | "client") => {
    this.setState({
      searchBy,
    });
  }

  private onClientSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
    this.setState({
      selectedClient: event.target.value,
    });
  }

  private onUsernameKeyUp = (e: React.KeyboardEvent) => {
    if (e.key.toLowerCase() === "enter") {
      this.handleSearch();
    }
  }

  private handleSearch = () => {
    this.props.getUsers(
      this.state.searchBy === "name" ? this.state.nameSearch : this.state.selectedClient,
      this.state.searchBy,
    )
  }
}

export { UserSearch };
